/**
 * TODO
 *
 * REFACTOR ONCE WE DO REPORTING PORTAL
 *
 */
import { formatCurrency } from "./DataFormatUtils";
import { formatRating } from "@limitless/common/utils";
const defaultMetricFormat = value => {
  return value;
};
export const metrics = [{
  label: "Earned",
  value: "expert.reward.fees",
  format: (value, profile) => formatCurrency(value, profile)
}, {
  label: "Questions Answered",
  value: "expert.resp",
  format: defaultMetricFormat
}, {
  label: "Questions Forwarded",
  value: "expert.escalate",
  format: defaultMetricFormat
}, {
  label: "Peer Reviewed",
  value: "expert.review.fee",
  format: defaultMetricFormat
}, {
  label: "Points Awarded",
  value: "expert.reward.points",
  format: defaultMetricFormat
}, {
  label: "Customer Rating",
  value: "expert.custResp.rating",
  format: value => formatRating(value)
}, {
  label: "Forward Reviewed",
  value: "expert.review.escalation",
  format: defaultMetricFormat
}, {
  label: "Quality Reviewed",
  value: "expert.review.quality",
  format: defaultMetricFormat
}];
export const DASHBOARD_METRICS = [metrics[0], metrics[1], metrics[2], metrics[3], metrics[4]];
export const DASHBOARD_WEEKLY_METRICS = [metrics[5]];